<!-- 党建专题 -->
<template>
<div :class="mobileClass('cm_part_subject_container')" v-show="dataEmpty">
  <div class="cm_part_subject_img">
    <img :src="data.img" alt="">
  </div>
  <!--<SpecialSubject v-for="item in data.data" :key="item.data.channelId" :data="item.data"  :indexUrl = "item.childImg" @dataChildEmpty="fromChild" />-->
  <SpecialSubject v-for="(item) in data.data" :key="item.data.channelId" :data="item.data" :parentAlias="ele.alias" :indexUrl = "item.childImg" v-show="hasAlias(webConfigue, item.data)"/>
</div>
</template>

<script>
import SpecialSubject from "@/components/party/SpecialSubject"
export default {
//import引入的组件需要注入到对象中才能使用
components: {SpecialSubject},
props:["data","ele"],
data() {
//这里存放数据
return {
  dataEmpty:true,
  isEmpty:[],
  webConfigue: JSON.parse(window.localStorage.getItem("webConfigue")),
  localUrl:window.SITE_CONFIG.baseUrl,
  imgUrl:[],
  windowWidth:document.documentElement.clientWidth

};
},
//监听属性 类似于data概念
computed: {
  mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
},
//监控data中的数据变化
watch: {
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
},
//方法集合
methods: {
  hasAlias: function (arr, alias1) {
    let alias = ""
    if (alias1 != "" && alias1 != undefined && alias1 != null) {
      alias = alias1.channelId
      for (let i = 0; i < arr.length; i++) {
        if (
                arr[i][this.ele.alias] != "" &&
                arr[i][this.ele.alias] != undefined &&
                arr[i][this.ele.alias] != null
        ) {
          for (let j = 0; j < arr[i][this.ele.alias].length; j++) {
            if (arr[i][this.ele.alias][j].TEMPLATE_ID == alias) {
              //let childObj ={}
              // childObj["path"] = this.localUrl + arr[i][this.ele.alias][j].FILE[0].PATH
              // childObj["alias"] = alias
              // this.imgUrl.put(childObj)
              return true;
            }
          }
        }
      }
      return false
    }else{
      return true;
    }
  },
  fromChild:function(childVulue){
    this.isEmpty.push(childVulue)
    if(this.isEmpty){
      for(let i = 0;i<this.isEmpty.length;i++){
        if(!this.isEmpty[i]){
          this.dataEmpty = false
        }
      }
    }
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},

}
</script>
<style scoped>
.cm_part_subject_container{
  width: 100%;
  margin-top: 20px;
  display:flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.cm_part_subject_img{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
}
.cm_part_subject_img>img{
  width:458px;
  height:100px;
}
</style>